<template>
  <div class="titleTemp2">
    <div class="title">{{data.title}}</div>
    <div class="subtitle">{{data.subtitle}}</div>
  </div>
</template>

<script>
export default {
  name: "titleTemp2",
  props: ["data"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.titleTemp2 {
  .title {
    font-size: 38px;
    color: rgba(58, 58, 58, 1);
    text-align: center;
    line-height: 53px;
  }
  .subtitle {
    font-size: 28px;
    color: rgba(153, 153, 153, 1);
    text-align: center;
    line-height: 40px;
    background: url("../assets/images/other/line.png") no-repeat bottom center / 280px
      3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/templates/titleTemp2.vue